// TODO: Find a way to make this more efficient. We would rather have 1 place to define colors in the app and have typescript files and .scss files reference that one place.
export const colorVariables = [
  '--blue',
  '--dark-blue',
  '--medium-blue',
  '--light-blue',
  '--green',
  '--dark-green',
  '--medium-green',
  '--light-green',
  '--disabled-green',
  '--red',
  '--dark-red',
  '--medium-red',
  '--light-red',
  '--yellow',
  '--dark-yellow',
  '--medium-yellow',
  '--light-yellow',
  '--purple',
  '--dark-purple',
  '--medium-purple',
  '--light-purple',
  '--black',
  '--dark-gray',
  '--gray',
  '--medium-gray',
  '--light-gray',
  '--lighter-gray',
  '--faint-gray',
  '--disabled-gray',
  '--white',
  '--lavender',
  '--light-lavender',
  '--orange',
  '--light-orange',
  '--pink',
  '--light-pink',
  '--teal',
  '--light-teal',
  '--chart-light-6-blue',
  '--chart-light-5-blue',
  '--chart-light-4-blue',
  '--chart-light-3-blue',
  '--chart-light-2-blue',
  '--chart-light-1-blue',
  '--chart-standard-blue',
  '--chart-dark-1-blue',
  '--chart-dark-2-blue',
  '--chart-dark-3-blue',
  '--chart-dark-4-blue',
  '--chart-dark-5-blue',
  '--chart-light-6-red',
  '--chart-light-5-red',
  '--chart-light-4-red',
  '--chart-light-3-red',
  '--chart-light-2-red',
  '--chart-light-1-red',
  '--chart-standard-red',
  '--chart-dark-1-red',
  '--chart-dark-2-red',
  '--chart-dark-3-red',
  '--chart-dark-4-red',
  '--chart-dark-5-red',
  '--chart-light-6-green',
  '--chart-light-5-green',
  '--chart-light-4-green',
  '--chart-light-3-green',
  '--chart-light-2-green',
  '--chart-light-1-green',
  '--chart-standard-green',
  '--chart-dark-1-green',
  '--chart-dark-2-green',
  '--chart-dark-3-green',
  '--chart-dark-4-green',
  '--chart-dark-5-green',
  '--chart-light-6-yellow',
  '--chart-light-5-yellow',
  '--chart-light-4-yellow',
  '--chart-light-3-yellow',
  '--chart-light-2-yellow',
  '--chart-light-1-yellow',
  '--chart-standard-yellow',
  '--chart-dark-1-yellow',
  '--chart-dark-2-yellow',
  '--chart-dark-3-yellow',
  '--chart-dark-4-yellow',
  '--chart-dark-5-yellow',
  '--chart-light-6-purple',
  '--chart-light-5-purple',
  '--chart-light-4-purple',
  '--chart-light-3-purple',
  '--chart-light-2-purple',
  '--chart-light-1-purple',
  '--chart-standard-purple',
  '--chart-dark-1-purple',
  '--chart-dark-2-purple',
  '--chart-dark-3-purple',
  '--chart-dark-4-purple',
  '--chart-dark-5-purple',
  '--chart-light-6-royal',
  '--chart-light-5-royal',
  '--chart-light-4-royal',
  '--chart-light-3-royal',
  '--chart-light-2-royal',
  '--chart-light-1-royal',
  '--chart-standard-royal',
  '--chart-dark-1-royal',
  '--chart-dark-2-royal',
  '--chart-dark-3-royal',
  '--chart-dark-4-royal',
  '--chart-dark-5-royal',
  '--chart-light-6-teal',
  '--chart-light-5-teal',
  '--chart-light-4-teal',
  '--chart-light-3-teal',
  '--chart-light-2-teal',
  '--chart-light-1-teal',
  '--chart-standard-teal',
  '--chart-dark-1-teal',
  '--chart-dark-2-teal',
  '--chart-dark-3-teal',
  '--chart-dark-4-teal',
  '--chart-dark-5-teal',
  '--chart-light-6-pink',
  '--chart-light-5-pink',
  '--chart-light-4-pink',
  '--chart-light-3-pink',
  '--chart-light-2-pink',
  '--chart-light-1-pink',
  '--chart-standard-pink',
  '--chart-dark-1-pink',
  '--chart-dark-2-pink',
  '--chart-dark-3-pink',
  '--chart-dark-4-pink',
  '--chart-dark-5-pink',
  '--chart-light-6-orange',
  '--chart-light-5-orange',
  '--chart-light-4-orange',
  '--chart-light-3-orange',
  '--chart-light-2-orange',
  '--chart-light-1-orange',
  '--chart-standard-orange',
  '--chart-dark-1-orange',
  '--chart-dark-2-orange',
  '--chart-dark-3-orange',
  '--chart-dark-4-orange',
  '--chart-dark-5-orange',
]
